export default {
	agree: 'Agree',
	agreeMsg: 'Terms and Privacy policy',
	signupAgree: 'Agree with Terms and Privacy policy',
	mustAgree: 'Please agree to the agreement and privacy policy first',
    openapp: 'Please open it in your browser',
	loading: 'Loading...',
	add: 'Add',
	delete: 'Delete',
	edit: 'Edit',
	sort: 'Sort',
	query: 'Search',
	resetting: 'Reset',
	copy: 'Copy',
	export: 'Export',
	handle: 'Action',
	back: 'Back',
	confirm: 'Confirm',
	cancel: 'Cancel',
	clear: 'Clear',
	close: 'Close',
	created_at: 'Create Time',
	updated_at: 'Update Time',
	required: 'Required items cannot be empty',
	successMsg: 'Successfully modified',
	errorMsg: 'Modification failed',
	opaSuccess: 'Operation successful',
	opaError: 'operation failed',
	prompt: 'Operation tips',
	Enter: 'Enter',
	EnterEpt: 'The submitted information is empty',
	PleaseSelect: 'Please select',
	Uploadfiles: 'Upload files',
	Previewfiles: 'Preview files',
	Downloadfiles: 'Download files',
	FileFormats: 'Supports the following file formats',
	FileName: 'file name',
	uploaded: 'uploaded',
	operator: 'operator',
	previewType: 'The current attachment does not support preview. Please download and view',
	DownloadSuccessful: 'Download successful',
	DownloadFailed: 'Download failed',
	Save: 'Save',
	SaveAndNext: 'Save And Next',
	nodata: 'No Data',
	refundSet: 'Refund handling fee settings',
	refundRate: 'Refund processing rate',
	commRate: 'Commission settlement time',
	commRateUnit: 'Day',
	refundCustom: 'Customer responsibility',
	refundbusiness: 'Undertaken by merchants',
	rateTips: 'Please enter the correct rate',
	commTips: 'Please enter the correct number of days',
	ProductDetials: 'Product Detials',
	UserDetials: 'User Details',
	Picture: 'Picture',
	ReceiptNo:'Receipt No.',
	Creationtime:'Creation time',
	Inboundtime:'Inbound time',
	Addnewcustomer:'Add new customer',
	Inputtoselectcustomer:'Input to select customer',
	Customername:'Customer name',
	CustomerTaxNo:'Customer Tax No.',
	CustomerPhone:'Customer Phone',
	Driverphone:'Driver phone',
	ShopNo:'Shop No.',
	Shopphone:'Shop phone',
	No:'No.',
	ItemNo:'Item No.',
	Material:'Material',
	Numberofpackages:'Number of packages',
	numberofboxes:'number of boxes',
	Totalquantity:'Total quantity',
	GW:'G.W(Kg)',
	TotalGW:'Total G.W(Kg)',
	Length:'Length(cm)',
	Width:'Width(cm)',
	Height:'Height(cm)',
	CBM:'CBM(m³)',
	TotalCBM:'Total CBM(m³)',
	Bytrain:'By train',
	Bytruck:'By truck',
	Markcolor:'Mark color',
	packagingmethod:'packaging method',
	Normal:'Normal',
	Compress:'Compress',
	White:'White',
	Yellow:'Yellow',
	input:'input',
	Total:'Total',
	Cancel:'Cancel',
	dashbord1:'Today new Receipt',
	dashbord2:'Today new packing list',
	dashbord3:'Draft packing list',
	dashbord4:'The total quantity of items transported by train in the warehouse',
	dashbord5:'The total quantity of items transported by truck in the warehouse',
	dashbord6:'Not chosen items',
	dashbord7:'Customers with no updates for more than X days',
	dashbord8:'Total Customers',
	customers1:'Total inbound items',
	customers2:'Total Transportation CBM',
	customers3:'No updates for more than X days',
	Operate:'Operate',
	Details:'Details',
	Edit:'Edit',
	Delete:'Delete',
	InboundorderNo:'Inbound order No.',
	ProductName:'Product Name',
	MaterialUsage:'Material Usage',
	DownloadExcel:'Download Excel',
	DownloadImage:'Download Image',
	DownloadQRcode:'Download QR code',
	CopyLink:'Copy Link',
	AddtoNewPackinglist:'Add to New Packing list',
	AddtoExistentPackinglist:'Add to Existent Packing list',
	saveOk:'Save successful',
	ConfirmDelete:'Confirm Delete',
	ConfirmDeleteOk:'Are you sure to Delete this?',
	Confirmoperation:'Confirm operation?',
	xxxxxxxx:'xxxxxxxx',
	app: {
		title: 'Kavkaz',
		logoText: 'Kavkaz',
		loginText: 'Kavkaz',
		miniLogoText: 'Kavkaz',
		username: 'Username',
		password: 'Password',
		captcha: 'Captcha',
		signIn: 'Sign in',
		Register: 'Register',
		signOut: 'Sign Out',
		large: 'Large',
		default: 'Default',
		small: 'Small',
		close: 'Close',
		closeOthers: 'Close Others',
		closeAll: 'Close All'
	},
	settings: {
		title: 'Layout Settings',
		sidebarDark: 'Dark Sidebar',
		sidebarLight: 'Light Sidebar',
		navbarLight: 'Light Navbar',
		navbarTheme: 'Theme Navbar',
		interface: 'Interface Settings',
		uniqueOpened: 'Unique Opened',
		logo: 'Enable Logo',
		dark: 'Enable Dark',
		breadcrumb: 'Enable Breadcrumb',
		tabs: 'Enable Tabs',
		tabsCache: 'Enable Tabs Cache',
		tabsStyle: 'Tabs Style',
		copyConfig: 'Copy Config',
		reset: 'Reset',
		copySuc: 'Copy Succeeded',
		style1: 'Style-1',
		style2: 'Style2',
		closeTab: 'Close',
		closeOther: 'Close Others',
		Currency: 'Currency',
		Unit: 'Unit',
		SystemDepartment: 'System Department',
		SystemUser: 'System User',
		MembershipPrice: 'Membership Price',
		Supports: 'Supports',
		Help: 'Help',
		Term: 'Term',
		Privacy: 'Privacy',
		Others: 'Other configurations',
		BaseInfo: 'My Profile',
		DepartmentInfo: 'Department Information',
		UserName: 'User Name',
		Clipper: 'KJNova Clipper',
		SelectImg: 'Select Picture',
		Confirmupload: 'Confirm upload',
		UploadImages: 'Upload images',
		ReUpload: 'Re-upload',
		Setting: 'Setting',
		SystemLanguage: 'System Language',
		DefaultCurrency: 'Default Product Currency',
		DefaultUnit: 'Default Product Unit',
		Membership: 'Membership',
		Support: 'Support',
		Upgrade: 'Upgrade',
		Vipuser: 'Vip Users',
	},
	table: {
        customerName:'Customer Name',
        customerphone:'Customer phone',
        customerTax:'Customer Tax NO.',
		TotalProducts: 'Total Products',
		LastProductActivityTime: 'Last Product Activity Time',
		name: 'Name',
		Operation: 'Operation',
		CurrencyName: 'Currency Name',
		Symbol: 'Symbol',
		SortValues: 'Sort Values',
		UnitName: 'Unit Name',
		Abbreviation: 'Abbreviation',
		DepartmentName: 'Department Name',
		WarehouseName: 'Warehouse Name',
		SystemUserID: 'System User ID',
		AccountStatus: 'Account Status',
		UserName: 'User Name',
		avatar: 'User profile',
		LoginAccount: 'Login account',
		MembershipName: 'Membership Name',
		Price: 'Price',
		Duration: 'Duration',
		MembershipDays: 'Renewal Days',
		WebPrice: 'Web Price',
		AndroidPrice: 'Android Price',
		IosPrice: 'Ios Price',
		SupportName: 'Support Name',
		PIC: 'PIC',
		value: 'value',
		SearchDepartmentName: 'Enter department name search',
		SearchWarehouseName: 'Enter warehouse name search',
		SearchCustomerName: 'Enter customer name search',
		SearchUserName: 'Enter name search',
		SearchLoginName: 'Enter login account search',
		Enable: 'Enable',
		Deactivate: 'Deactivate',
		SetPermissions: 'Set permissions',
		ResetPassword: 'reset password',
		EnterPassword: 'Please enter a new password',
		PasswordAuthentication: 'The password must include upper and lower case letters and numbers, at least 8 digits.',
		EditPermissions: 'Edit permissions',
		SelectAll: 'Select All',
		DeselectAll: 'Deselect All',
		NoPermissions: 'No configurable permissions',
		ContactInformation: 'contact information',
		LoginPassword: 'Login password',
		AccountEmail: 'Account Email',
		AccountName: 'Account Name',
		AccountPosition: 'Account Position',
		ContactsType: 'Type',
		NameCard: 'Name Card',
		CreatedBy: 'Created By',
		EditedBy: 'Edit By',
		FileName: 'File Name',
		FileBy: 'By',
		TotalAmount: 'Total Amount',
		TotalRefund: 'Refund amount',
		Gift: 'Gift',
		PaymentID: 'Payment ID',
		PaymentStatus: 'Payment Status',
		PaymentUserName: 'User Name',
		UserEmai: 'User Emai',
		UserPhone: 'User Phone',
		PaymentType: 'Type',
		PaymentTime: 'Payment Time',
		PaymentAmount: 'Payment Amount',
		RefundAmount: 'Refund Amount',
		RefundAmountTips: 'Deduction of handling fees',
		PaymentChannel: 'Payment Channel',
		WechatPay: 'WeChat scanning payment',
		PaymentDuration: 'Duration',
		XufeiDuration: 'Duration',
		Picture: 'Product photos',
		ProductName: 'Product Name',
		ItemNumber: 'Item Number',
		ProductPrice: 'Price',
		Unit: 'Unit',
		Contact: 'Contact',
		Tag: 'Tag',
		Basicinformation: 'Basic information',
		MaxImgSize: 'Picture maximum 10M',
		UpImgTips: 'When uploading an image, it can be cropped as a square. When cropping, the image can be enlarged or reduced',
		Description: 'Description',
		hsCode: 'HS Code',
		Packinginformation: 'Packing information',
		PackingQTY: 'Packing QTY',
		InnerPacking: 'Inner Packing',
		PackingSize: 'Packing Size',
		CBM: 'CBM',
		GrossWeight: 'Gross Weight',
		NetWeight: 'Net Weight',
		MOQ: 'MOQ',
		Remark: 'Remark',
		UserID: 'User ID',
		UserAvater: 'User Avater',
		UserLink: 'User Link',
		UserRegisterTime: 'User Register Time',
		LastActivityTime: 'Last Activity Time',
		Membership: 'Membership',
		UserDuration: 'Duration',
		Active: 'Active',
		Inactive: 'Inactive',
		pay: 'pay',
		confirm: 'confirm',
		gift: 'gift',
		RegisterSource: 'Registration source',
		inviteUser: 'Inviter',
		inviteRate: 'Current promotion commission ratio',
		inviteAmount: 'Total amount of promotion commission',
		inviteAmounTX: 'Total amount that can be withdrawn',
		inviteAmountBTX: 'Non withdrawable amount',
		inviteAmountYTX: 'Withdrawn amount',
		barcode: 'Barcode',
		addbarcode: 'Generate barcode',
		savebarcode: 'Save',
		enterbarcode: 'Please enter the barcode number',
		enterbarcodeRight: 'Please enter the correct barcode',
        Withdrawaltime: 'Withdrawal time',
        Withdrawalamount: 'Withdrawal amount',
        Withdrawalchannels: 'Withdrawal channels',
        Withdrawalhandlingfee: 'Withdrawal handling fee',
	},
	operation: {
		NewCurrency: 'New Currency',
		NewUnit: 'New Unit',
		NewDepartment: 'New Department',
		NewSystemUser: 'New System User',
		ActiveAccounts: 'Active Accounts',
		InactiveAccounts: 'Inactive Accounts',
		ReleaseAccount: 'Release Account',
		ReleaseConfirm: 'Are you sure to release the account?',
		Renew: 'Renew',
		All: 'All',
		SearchAccounts: 'Search Accounts',
		SearchContacts: 'Search Contacts',
		SearchPayment: 'Search User Name & Phone & Email',
		SearchProducts: 'Search Products',
		SearchTags: 'Search Tags',
		Buyers: 'Buyers',
		Suppliers: 'Suppliers',
		PaymentStartTime: 'Payment Start Time',
		PaymentEndTime: 'Payment End Time',
		StartTime: 'Start Time',
		EndTime: 'End Time',
		RegisterStartTime: 'Register Start Time',
		RegisterEndTime: 'Register End Time',
		ConfirmPayment: 'Confirm Payment',
		Refund: 'Refund',
		GiftMonth: 'One month',
		GiftYear: 'One Year',
		NeedSelect: 'Please select the product that needs to be deleted',
		NeedSelectExport: 'Please select the product that needs to be exported',
		EnterFileName: 'Please enter a file name',
		ChooseAs: 'Choose As',
		Quotation: 'Quotation',
		Packinglist: 'Packing list',
		Invoice: 'Invoice',
		ExoprtFile: 'Export To Excel',
		ChoosePic: 'Please select a product image',
		EnterProName: 'Please enter the product name',
		TotalUsers: 'Total Users',
		Freeze: 'Freeze',
		Unfreeze: 'Unfreeze',
		UserFreeze: 'User Freeze',
		UserUnfreeze: 'User Unfreeze',
		FreezeTime: 'Freeze duration',
		FreezeDay1: '3 days',
		FreezeDay2: '7 days',
		FreezeDay3: 'Permanent',
        inviteTxBtn: 'Add withdrawal record',
	},
	error: {
		email: 'The email format is incorrect',
		password: 'The password cannot be less than {len} digits',
		captcha: 'Verification code error',
		successLogin: 'Login succeeded',
		failLogin: 'Login failed',
	},
	router: {
		home: 'Home',
		profilePassword: 'Change Password'
	},
	menu: {
		PageUser: 'Users',
		PagePayment: 'Payment',
		PageSettings: 'Settings',
		PagenSystem: 'menuConfig',
		ChangePassword: 'Change Password',
		Me: 'My Profile',
		PageProducts: 'Products',
		PageContacts: 'Contacts',
		PageAccounts: 'Accounts',
		PageFile: 'File History',
		PageMembership: 'Membership',
		ModifyAvatar: 'Modify Avatar',
		ModifyName: 'Modify Name',
		Freeze: 'Freeze',
		Unfreeze: 'Unfreeze',
		ResetPassword: 'Reset Password',
		Gift: 'Gift',
		ConfirmPayment: 'Confirm Payment',
		Refund: 'Refund',
		Currency: 'Currency',
		Unit: 'Unit',
		SystemDepartment: 'System Department',
		SystemUser: 'System User',
		MembershipPrice: 'Membership Price',
		Supports: 'Supports',
		Vipuser: 'Vip Users',
		Help: 'Help',
		Term: 'Term',
		Privacy: 'Privacy',
		Others: 'Other configurations',
		add: 'add',
		delete: 'delete',
		edit: 'edit',
		export: 'export',
		copy: 'Copy',
		SetPermissions: 'Permissions',
		ActiveAccounts: 'Active Accounts',
		InactiveAccounts: 'Inactive Accounts',
		Renew: 'Renew',
		ReleaseAccount: 'Release account',
		Buy: 'Purchase Member',
		rate: 'Set commission ratio',
		promotion: 'Promotion management',
		promotionlogs: 'Promotion record',
        UserTx: 'Add withdrawal record',
        push: 'Push management',
        pushLog: 'Message push record',
        addPushLog: 'Add message push',
        dateAnalysis:'Date Analysis',
        dashbord:'Dashbord',
        customers:'Customers',
        receiptM:'Receipt M',
        newReceipt:'New Receipt',
        receiptDetails:'Receipt Details',
        receiptsList:'Receipts List',
        byTrain:'By Train',
        ByTruck:'By Truck',
        notChosen:'Not Chosen',
        packingM:'Packing M',
        newPackingList:'New Packing List',
        packingListDetails:'Packing List Details',
        packingLists:'Packing Lists',
        fileM:'File M',
        deapartment:'Deapartment',
        werehouse:'Warehouse',
        user:'User',
        customer:'Customer'
	},
	profile: {
		username: 'Username',
		company_name: 'Company Name',
		phone: 'Phone',
		address: 'Address',
		website: 'Website',
		oldPassword: 'Original Password',
		newPassword: 'New Password',
		confirmPassword: 'Confirm Password',
		enterNewPassword: 'Enter a new password',
		minDigits: 'Password with a minimum of six digits',
		enterNewPasswordAgain: 'Please enter the new password again',
		inconsistent: 'The two passwords do not match. Please try entering again',
		success: 'Password modification successful',
		errorMsg: 'Your account is abnormal. Please log in again and change your password',
	},
	axios: {
		Uploading: 'Uploading',
		Submitting: 'Submitting',
		Sending: 'Sending',
		Registering: 'Registering',
		Loading: 'LOADING',
		Saving: 'Saving',
		Deleting: 'Deleting',
		DeleteTips: 'Are you sure to proceed with the deletion operation?',
		buyLoading: 'Order submission in progress',
	},
	login: {
		Email: 'Email/Phone',
		EmailVer: 'Please enter the correct email/phone number',
		EmailTips: 'Enter your email address or Phone number',
		EmailSuccess: 'We have sent a verification link to your email. Please go to your email and click on the verification link to register successfully.',
		EmailReset: 'We have sent a Reset Password link to your email. Please go to your email and go next.',
		nameTips: 'Enter your name',
		passTips: 'Enter your password',
		captchaTips: 'Please enter the verification code',
		goLogin: 'Go to Login',
		goAPP: 'Log in and use within the app',
		ResetPassword: 'reset password',
		EmailName: 'Email',
		NewPassword: 'New Password',
		EnterNewPassword: 'Please enter a new password',
		ConfirmModification: 'Confirm modification',
		ResetEnd: 'Password reset successful, please remember your new password.',
		ClientLogin: 'Client Login',
		ManagementLogin: 'Management login',
		ForgotPassword: 'Forgot Password',
		SendCodeOk: 'The verification code has been successfully sent. Please check it carefully.',
		RegisterOk: 'Registration successful, please remember your password.',
		ResetOk: 'Reseted, Login Now',
		Resend: 'Resend',
		verCode: 'SMS verification code',
		EnterCode: 'Please enter the SMS verification code',
		sendCode: 'Send verification code',
		RegResult: 'Registration results',
		ResetResult: 'Reset Results',
		verEmail: 'Email verification',
		verSms: 'SMS verification',
	},
	membership: {
		Free: 'Free',
		Basic: 'Basic',
		Company: 'Company',
		Sub: 'Employee account',
		FreePro1: 'Max add 5 products',
		FreePro11: 'After upgrading, products can be added without restrictions',
		FreePro2: '5 free exports',
		FreePro22: 'Unlimited export after upgrade',
		BasicPro1: 'Unlimited products',
		BasicPro2: 'Unlimited exports',
		BasicPro3: 'Can export as quotation and packing list',
		CompanyPro1: 'Admin account + 4 employee accounts',
		CompanyPro2: 'Every account can access same database of products and files',
		BuyAccounts: 'More Employee Accounts',
		BuyPro: 'Can add additional accounts for {year}    {month}',
		Agree: 'Agree to payment agreements and policies',
		mustAgree: 'Please choose to read and agree to the payment agreement and policy',
		Month: 'Month',
		Year: 'Year',
		Unpaid: 'Unpaid',
		Paid: 'Paid',
		PartialRefund: 'Partial refund',
		Refunded: 'Refunded',
		Fail: 'Fail',
		ConfirmPayment: 'Confirm Payment',
		ConfirmTips: 'Confirm payment for giving away user members, please use with caution',
		GoPay: 'The order has been successfully created. Please proceed to payment',
		ConfirmPay: 'Payment confirmation',
		EndPay: 'Payment completed',
		Confirm: 'Confirm',
		ConfirmRefund: 'Confirm refund',
		Refund: 'Refund',
		EnterRefund: 'Enter the refund amount',
		RefundTips: 'which cannot exceed the payment amount',
		RefundWarning: 'Refund will recover corresponding benefits',
		ExpireTime: 'Expiration time',
		IsFreezed: 'The user has been frozen',
		InFreezed: 'Thawing time: {time}',
		AmountsMax: 'The number of new employee accounts has been exhausted',
		AmountsMaxTips: 'You can choose to purchase more employee accounts',
		paySuccess: 'The order has been successfully paid',
	},
    invite: {
        link: 'Invite Link',
        wechat: 'Wechat',
        qq: 'QQ',
        rate: 'commission ratio',
        setRate: 'Promotion commission ratio',
        setRenRate: 'Renewal commission ratio',
        setRateOne: 'Tier 1 Promotion commission ratio',
        setRenRateOne: 'Tier 1 Renewal commission ratio',
        setRateTwo: 'Tier 2 Promotion commission ratio',
        setRenRateTwo: 'Tier 2 Renewal commission ratio',
        enterTips: 'Please enter commission sharing ratio(0~100)',
        Inviteraccount: 'Inviter account',
        Invitedpersonaccount: 'Invited person account',
        Paymenttime: 'Payment success time',
        Paymentamount: 'Payment amount',
        Paymentchannels: 'Payment channels',
        MemberType: 'Type',
        Commissionamount: 'Commission amount',
        canWithdraw: 'The withdrawable amount is 0',
        searchaccount: 'Search by account',
        promotion: 'My promotion',
        amount: 'Total amount',
        received: 'Amount received',
        withdrawable: 'Withdrawable',
        type: 'Type',
        time: 'Time',
        commission: 'Commission',
		editTx: 'Modify the withdrawable cash amount',
		editTxNow: 'Current withdrawable amount:',
		editTxTips: 'Please enter the correct amount',
    },
    push: {
        sub: 'Once submitted, it cannot be revoked. Do you want to confirm the submission and send it?',
        add: 'Submit push message',
        request_id: 'Push unique ID',
        title: 'Push title',
        content: 'Push content',
        payload: 'Push jump data',
        push_clientids: 'Receive message users',
        push_system: 'Push system type',
        push_result: 'Push status',
        all: 'All platforms',
        ios: 'Ios',
        and: 'Android',
        wx: 'WeChat Mini Program',
        success: 'Push successful',
        fail: 'Push failed',
        userlist: 'List of message receiving users',
        alluser: 'All users',
        setuser: 'Specify user',
        iosuser: 'Ios users',
        anduser: 'Android users',
        nouser: 'There are currently no users available to receive push messages',
    }
}
